<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-content">
        <div class="w-full max-w-lg p-6 bg-white shadow-lg rounded-lg">
          <div class="flex flex-col">

            <div class="mb-4">
              <label class="text-gray-700">Type</label>
              <v-select @input="changeParam" v-model="type" :options="reportTypes" class="w-full mt-1"
                placeholder="Select report type" />
            </div>


            <div v-if="type.value === 'custom'" class=" mb-4">
              <v-date-picker v-model="dateRange" :columns="2" :max-date="new Date()" class="w-full" is-range />
            </div>

            <div class="mb-4">
              <label class="text-gray-700">Driver</label>
              <v-select v-model="driver" :options="drivers" class="w-full mt-1" placeholder="Select driver" />
            </div>


            <div class="mb-4">
              <label class="text-gray-700">Comment</label>
              <input type="text" v-model="comment" class="w-full mt-1 p-2 border border-solid border-grey rounded-4px"
                placeholder="Enter your comment" />
            </div>


            <div class="flex mt-6 gap-3 self-end">
              <vs-button @click="cancel" class="bg-grey-light text-black">
                Cancel
              </vs-button>
              <vs-button @click="submitForm">
                Send
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: { vSelect },
  data() {
    return {
      reportTypes: [
        { label: 'Custom range report', value: "custom" },
        { label: 'Roadside inspection DOT report (8 day)', value: '' }],
      type: { label: 'Roadside inspection DOT report (8 day)', value: '' },
      dateRange: null,
      driver: null,
      comment: '',
    };
  },
  methods: {
    submitForm() {
      if (!this.driver || !this.comment) return

      let query = {
        driver_name: this.driver.value,
        comment: this.comment,
      }

      if (this.dateRange && this.dateRange.end) {
        query.start_year = this.dateRange.start.getFullYear()
        query.end_year = this.dateRange.end.getFullYear()
        query.start_month = this.dateRange.start.getMonth() + 1
        query.end_month = this.dateRange.end.getMonth() + 1
      }

      this.$store.dispatch('fmcsaReports/createReport', query)
        .finally(res => {
          this.comment = ''
          this.driver = ''
          this.dateRange = null,
            this.type = this.reportTypes[1]
        })

    },
    cancel() {
      this.$emit('cancel');
    },
    changeParam() {
      if (!this.type) {
        this.type = this.reportTypes[1]
        return
      }
    },
    cancelForm() {
      this.type = 'Custom range report'
      this.dateRange = null
      this.driver = null
      this.comment = ''
      
    },
  },
  computed: {
    drivers() {
      return this.$store.state.fmcsaReports.drivers;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  animation: fadeIn 0.3s forwards;
}


::v-deep .custom-multiple-select .vs__selected-options {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar {
  height: 2px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-thumb {
  background-color: #a0a0a0;
  /* Color of the scrollbar thumb */
  border-radius: 0px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  /* Color of the scrollbar track */
}

.modal-container {
  position: relative;
  top: 7%;
  width: 100%;
  max-width: 700px;
  border-radius: 8px;
  transform: translateY(-100%);
  animation: slideIn 0.5s forwards ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
